import type { ComponentProps, FC, ReactNode } from 'react';

import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@shared/components/ui';

export interface GenericModalProps {
  open: boolean;
  onOpenChange?: (open: boolean) => void;
  title?: ReactNode;
  description?: ReactNode;
  children?: ReactNode;
  contentProps?: ComponentProps<typeof DialogContent>;
  showCloseButton?: boolean;
}

export const GenericModal: FC<GenericModalProps> = ({
  open,
  onOpenChange,
  title,
  description,
  children,
  contentProps,
  showCloseButton = false,
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        {...(description ? {} : { 'aria-describedby': undefined })}
        {...contentProps}
        showCloseButton={showCloseButton}
      >
        {(title ?? description) && (
          <DialogHeader className="flex flex-col gap-2 text-center sm:text-left">
            {title && <DialogTitle>{title}</DialogTitle>}
            {description && <DialogDescription asChild>{description}</DialogDescription>}
          </DialogHeader>
        )}

        {children}
      </DialogContent>
    </Dialog>
  );
};
